<div>
    <div class="desktop">
        <div class="box-container">
            <div class="m-3 center">
                <div class="row">
                    <div class="col-3">
                        <div class="p-2 clickable" [routerLink]="['/']">
                            <img class="logo-img" src="../../../assets/img/logo_go_contratos.png">
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="row">
                            <div class="col text-center">
                                <div class="pt-3 nowrap">
                                    <p class="header-item"><a href="https://gocontratos.com.br/o-software" target=”_blank”>{{i18n.HOME.THE_SOFTWARE}}</a></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3">
                                    <p class="header-item"><a href="https://gocontratos.com.br/precos" target=”_blank”>{{i18n.HOME.PRICE}}</a></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3 clickable nowrap">
                                    <p class="header-item"><a href="https://gocontratos.com.br/conteudo-2" target=”_blank”>{{i18n.HOME.CONTENT}}</a>&nbsp;&nbsp;<i class="fas fa-chevron-down  blue"></i></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3 clickable nowrap">
                                    <p class="header-item"><a href="https://gocontratos.com.br/sobre-nos" target=”_blank”>{{i18n.HOME.ABOUT}}</a>&nbsp;&nbsp;
                                        <i class="fas fa-chevron-down  blue"></i>
                                    </p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3">
                                    <p class="header-item"><a href="https://gocontratos.com.br/contato" target=”_blank”>{{i18n.HOME.CONTACT}}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="button-blue-desk d-flex justify-content-center align-items-center">
                            <p class="header-item"><a href="https://signer-qa.gocontratos.com">{{i18n.HOME.ACCESS_ACCOUNT}}</a></p>
                        </div>
                    </div>
                    <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="box-shadow-flag f-12-rb p-2 text-center clickable">
                                <div *ngIf="language == 'pt_BR'" (click)="setLanguage('en_US')">
                                    <span class="ml-1">{{i18n.HOME.CHANGE_LANGUAGE}}</span>&nbsp;&nbsp;<img
                                        src="../../../assets/img/arrow_down.png" />
                                    <img class="pl-2" src="../../../assets/img/flag_brazil.png" />
                                </div>
                                <div *ngIf="language == 'en_US'" (click)="setLanguage('pt_BR')">
                                    <span class="ml-1">{{i18n.HOME.CHANGE_LANGUAGE}}</span>&nbsp;&nbsp;<img
                                        src="../../../assets/img/arrow_down.png" />
                                    <img class="pl-2" src="../../../assets/img/flag_usa.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="box-content">
                <div class="row mr-0">
                    <div class="col">
                        <div class="box-content-data">
                            <div class="pt-4">
                                <div class="p-5 text-center mt-5">
                                    <p class="f-40-rb blue-dark lighter">{{i18n.HOME.ACCESS_ACCOUNT}}</p>
                                    <div class="pt-2 mt-5">
                                        <div class="box-input mt-4">
                                            <i class="f-20 fas fa-user gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i><input
                                                type="text" placeholder="{{i18n.HOME.USER_NAME}}" />
                                        </div>
                                        <div class="box-input mt-4">
                                            <i
                                                class="ml-2 f-20 fas fas fa-lock-alt gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i><input
                                                type="password" placeholder="{{i18n.HOME.PASSWORD}}" />
                                        </div>
                                        <div class="button-blue mt-5">
                                            <div class="pt-2">
                                                <p class="white pt-2 f-14-rb">{{i18n.HOME.TEXT_ENTER}}</p>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="text-center mt-1 clickable">
                                                <p class="f-11-os gray">{{i18n.HOME.FORGET_PASSWORD}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="pt-4">
                            <div class="pt-4 mt-5 white">
                                <p class="text-title bold">{{i18n.HOME.TITLE}}</p>
                                <p class="text-content">{{i18n.HOME.HELP_COMPANY}}</p>
                            </div>
                            <div class="box-button mt-5">
                                <div class="text-center">
                                    <div class="button-orange">
                                        <div class="pt-1">
                                            <p class="white pt-1 f-19-rb bold"><a class="white"
                                                    [routerLink]="['/register']">{{i18n.HOME.TEST_FREE}}</a></p>
                                        </div>
                                    </div>
                                    <div class="text-center mt-2">
                                        <p class="f-16-os white">{{i18n.HOME.NO_NEED_CREDIT_CARD}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="mobile">
        <div class="m-3">
            <div class="row">
                <div class="col">
                    <div class="p-2">
                        <i class="f-26 fas fa-bars"></i>
                    </div>
                </div>
                <div class="col right">
                    <div class="d-flex flex-row-reverse">
                        <div class="box-shadow-flag p-2">
                            <div *ngIf="language == 'pt_BR'" (click)="setLanguage('en_US')">
                                <img src="../../../assets/img/arrow_down.png" />
                                <img class="pl-2" src="../../../assets/img/flag_brazil.png" />
                            </div>
                            <div *ngIf="language == 'en_US'" (click)="setLanguage('pt_BR')">
                                <img src="../../../assets/img/arrow_down.png" />
                                <img class="pl-2" src="../../../assets/img/flag_usa.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="box-content white">
            <div class="p-5 text-center">
                <p class="f-28-os bold">{{i18n.HOME.TITLE}}</p>
                <p class="f-16-os">{{i18n.HOME.HELP_COMPANY}}</p>
            </div>
        </div>
        <div class="box-content-data m-4">
            <div class="p-4 text-center mt-3">
                <p class="f-20-rb blue-dark lighter">{{i18n.HOME.ACCESS_ACCOUNT}}</p>
                <div class="mt-5">
                    <div class="box-input mt-4">
                        <i class="ml-2 fas fa-user gray-light">&nbsp;&nbsp;</i><input type="text"
                            placeholder="{{i18n.HOME.USER_NAME}}" />
                    </div>
                    <div class="box-input mt-4">
                        <i class="ml-2 fas fas fa-lock-alt gray-light">&nbsp;&nbsp;</i><input type="password"
                            placeholder="{{i18n.HOME.PASSWORD}}" />
                    </div>
                    <div class="button-blue mt-4">
                        <div class="pt-1">
                            <p class="white pt-2 f-14-rb">{{i18n.HOME.TEXT_ENTER}}</p>
                        </div>
                    </div>
                    <div class="mt-3">
                        <div class="text-center mt-1">
                            <p class="f-11-os gray">{{i18n.HOME.FORGET_PASSWORD}}</p>
                        </div>
                    </div>
                    <app-upload-file *ngIf="uploadFile"></app-upload-file>
                    <app-associate-subscriber *ngIf="associateSubscriber"></app-associate-subscriber>
                    <app-verify-signature></app-verify-signature>
                    <app-toast></app-toast>
                </div>
            </div>
        </div>

        <div class="box-button mt-4">
            <div class="text-center">
                <div class="button-orange">
                    <div class="pt-1">
                        <p class="white pt-2 f-14-rb"><a class="white"
                                [routerLink]="['/register']">{{i18n.HOME.TEST_FREE}}</a></p>
                    </div>
                </div>
                <div class="text-center mt-2">
                    <p class="f-11-os gray">{{i18n.HOME.NO_NEED_CREDIT_CARD}}</p>
                </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdropImage" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <img [src]="imagePath" class="rounded mx-auto d-block">
            </div>
        </div>
    </div>
</div>